import { useMemo } from 'react'
import { useStrackProps } from '../../components/Strack/hooks'
import { ViewStrackProps } from '../../components/Views/Views.types'

export const useDiagnosticsViewStrackProps = (view): ViewStrackProps => {
  const strackProps = useStrackProps()

  // Manage canvas visibility //
  const hiddenCanvases = useMemo(() => {
    return []
  }, [])
  // ============= //

  return useMemo(() => {
    return {
      enabled: true,
      ...strackProps,
      hiddenCanvases
    }
  }, [strackProps, hiddenCanvases])
}
